<!--
================================================
Un composant qui embarque le widget freshchat : https://web.freshchat.com/a/255682944539276/settings/widget

@todo : IMPORTANT : pour le moment inclure ce widget casse les tests cypress !

Url d'accès :

NOTE :  pour le moment je n'ai aps réussi à ajouter des champs personnalisés pour customiser le prénom, nom, email etc. Le chargement de script externe ne permet pas en suite de récupérer les data vuejs.

Pour le moment le composant ne sert pas à grans chose, j'aurai pu charger le script via vue google tag manager, mais je laisse ici pour le moment, cela permettra d'ajouter du tracking d'évenement pour l'ouverture du chat et plus tard d'ajouter la customisation des champs personnalisés (https://developers.freshchat.com/web-sdk/#user-properties)



*

================================================
-->


<!------------------------------------------------
+++++++++++++++++++++ HTML +++++++++++++++++++++++
-------------------------------------------------->

<template>
    <div id="LiveChatComp">
<!--        {{'Hello ! :) I am ' + $options.name}}-->
<!--        <div id="liveChatUserEmail">{{user.email}}</div>-->
    </div>
</template>

<!------------------------------------------------
+++++++++++++++++++ JAVASCRIPT++++++++++++++++++++
-------------------------------------------------->


<script>
    import {mapState} from 'vuex'
    // import SentryMixin from "../mixins/SentryMixin.js";
    // import SpinnerLoaderComp from "./SpinnerLoaderComp.vue";
    // import GlobalErrorNotification from "../mixins/GlobalErrorNotificationMixin.js";
    // import InterceptorMixin from "../mixins/InterceptorMixin.js";

    export default {
        name: 'LiveChatComp', //utile dans vue dev tool
        // mixins: [GlobalErrorNotification, SentryMixin, InterceptorMixin],
        // components: {},

        // props: {
            // pour typage voir :https://fr.vuejs.org/v2/guide/components-props.html#Types-des-props
            // placeholder : String, // attribut placeholder du champ
        // },
        data: function () {
            return {
                locale : this.$route.params.locale

                ,userFirstname: ''
                // pour les composants où l'user est identifié ///////////////////////
                // organizationSlug: this.$route.params.organization
                // userSlug: JSON.parse(this.$cookie.get('auth')).userSlug)
                // componentIsReady : false, // indique quand le composant est prêt à être afficher
                // =================================================================
            }
        },

        computed:{
            // computed props for store :
            ...mapState({
                user: state => state.user
            }),

            //----------------------------------------------

            // vuex 2-way data binding forms https://vuex.vuejs.org/guide/forms.html#two-way-computed-property
            // email: {
            //     get () {return this.$store.state.user.email},
            //     set (value) {this.$store.commit('UpdateUserEmail', value)}
            // },

            //----------------------------------------------

            // other computed props :
            // compProp: {
            //     get: function () {return this.foo},
            //     set: function (newValue) {this.foo = newValue}
            // }

        },
        watch: {
            // à chaque fois que la prop computed user change, cette fonction s'exécutera
            user: function () {

                // if(!_.isEmpty(this.user)){
                //     // this.initFreshChat()
                //     // this.userFirstname = this.user.firstname
                //     // this.initFreshChat(this.user)
                //
                // }
            }
        },


        methods: {



        },

        // LIFECYCLE HOOKS (https://v2.vuejs.org/v2/guide/instance.html#Lifecycle-Diagram)
        mounted: function () {


            // inclusion du code freshchat : https://web.freshchat.com/a/255682944539276/settings/widget

                function initFreshChat() {
                    window.fcWidget.init({
                        token: "4f229f67-05c7-405a-aefb-8cc1b7e91b4e",
                        host: "https://wchat.freshchat.com",
                    });


                    //  je n'ai pas réussi à passer les données custom avec vue
                    // https://developers.freshchat.com/web-sdk/#user-properties
                    // window.fcWidget.user.setProperties({
                        // firstName: '',
                        // lastName: '',
                        // email: self.user.email,
                        // phone: <phone>,
                        // phoneCountry: <country_code>,
                        // "plan": "Estate",
                        // "status": "Active",
                        // "Last Payment": "12th August"
                    // });

                }


                function initialize(i, t) {
                    var e;
                    i.getElementById(t) ? initFreshChat() : ((e = i.createElement("script")).id = t, e.async = !0, e.src = "https://wchat.freshchat.com/js/widget.js", e.onload = initFreshChat, i.head.appendChild(e))
                }

                function initiateCall() {
                    initialize(document, "freshchat-js-sdk")
                }

                window.addEventListener ? window.addEventListener("load", initiateCall, !1) : window.attachEvent("load", initiateCall, !1);


                    ////////////////: WIDGET FRESHDESK ///////////////
        }
    }
</script>

<!------------------------------------------------
++++++++++++++++++++++ CSS +++++++++++++++++++++++
-------------------------------------------------->

<!-- Add "scoped" attribute to limit CSS to this component only -->
<!--<style scoped lang="scss">-->
<!--    @import "../assets/css/globalVar.scss";-->
<!--    /*@import "../assets/css/bulmaResponsiveDep.scss";*/-->

<!--</style>-->
